import heroImg from "@/assets/cc_main_hero.png";
import { trackEvent } from "@/lib/analytics";

export function Hero() {
  return (
    <section id="top" className="relative min-h-[100svh] w-full overflow-hidden">
      <img
        src={heroImg}
        alt="Person inside an immersive LED stadium cube"
        width={1920}
        height={1280}
        className="absolute inset-0 w-full h-full object-cover scale-105"
      />
      <div className="absolute inset-0" style={{ background: "var(--gradient-hero)" }} />
      <div className="absolute inset-0 led-grid opacity-30" />
      <div className="absolute inset-0 scan-lines" />

      <div className="relative z-10 mx-auto max-w-7xl px-6 pt-40 pb-24 min-h-[100svh] flex flex-col justify-end">
        <div className="max-w-4xl animate-float-up">
          <div className="inline-flex items-center gap-2 px-3 py-1 mb-6 border border-primary/40 bg-primary/10 text-primary text-[11px] uppercase tracking-[0.25em] rounded-sm">
            <span className="w-1.5 h-1.5 bg-primary rounded-full animate-pulse-glow" />
            Now Raising $10M · Flagship Round
          </div>
          <h1 className="font-display text-5xl sm:text-7xl lg:text-8xl leading-[0.95] text-foreground">
            Step Inside the Most <span className="text-gradient-ember">Iconic Moments</span> in Sports.
          </h1>
          <p className="mt-6 max-w-2xl text-base sm:text-lg text-muted-foreground leading-relaxed">
            ClutchCube is the world's first immersive sports simulation chamber — a physical
            entertainment experience built for the Experience Economy. Using seamless LED
            environments, stadium-grade audio, real gameplay challenges, and cinematic video
            capture, ClutchCube transforms fans from spectators into participants.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="#invest"
              onClick={() => trackEvent("investor_cta_click", { placement: "hero" })}
              className="inline-flex items-center justify-center px-7 py-4 bg-primary text-primary-foreground font-semibold uppercase tracking-widest text-sm rounded-sm shadow-glow hover:translate-y-[-2px] transition"
            >
              Request Investor Deck
            </a>
            <a
              href="#experience"
              className="inline-flex items-center justify-center px-7 py-4 border border-border bg-background/40 backdrop-blur text-foreground font-semibold uppercase tracking-widest text-sm rounded-sm hover:border-primary/60 transition"
            >
              Explore the Experience
            </a>
          </div>

          <p className="mt-8 text-xs uppercase tracking-[0.3em] text-muted-foreground/80 max-w-xl">
            Building the flagship proof-of-concept location and franchise blueprint for a new
            category of physical sports entertainment.
          </p>
        </div>
      </div>
    </section>
  );
}
